import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { BloxButton } from "styled_components/Common/BloxButton";
import { Hamburger } from "./Hamburger";
import Tag from "./Tag";

const expand = keyframes`
    from {
        width: 4rem;
        height: 4rem;
    }
    to {
        width: 20rem;
        height: 13rem;
    }
`;

const collapse = keyframes`
    from {
        width: 20rem;
        height: 13rem;
    }
    to {
        width: 4rem;
        height: 4rem;
    }
`;

const expandLarge = keyframes`
    from {
        width: 5rem;
        height: 10rem;
    }
    to {
        width: 30rem;
        height: 20rem;
    }
`;

const collapseLarge = keyframes`
    from {
        width: 30rem;
        height: 20rem;
    }
    to {
        width: 5rem;
        height: 10rem;
    }
`;

const Container = styled.div`
  min-width: 100%;
  display: flex;
  height: ${({ expanded }) => (expanded ? "10rem" : "4rem")};
  width: ${({ expanded }) => (expanded ? "20rem" : "2rem")};
  color: ${({ theme }) => theme.text};
  background-color: rgba(212, 215, 216, 0.8);
  transition: all 0.3s ease-in-out;
  animation: ${({ expanded }) => (expanded ? expand : collapse)} 0.3s forwards;
  position: absolute;
  top: 0;
  right: 0;
  transform-origin: top right;
  overflow: hidden;
  z-index: 100;

  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    height: ${({ expanded }) => (expanded ? "20rem" : "5rem")};
    width: ${({ expanded }) => (expanded ? "40rem" : "3rem")};
    animation: ${({ expanded }) => (expanded ? expandLarge : collapseLarge)}
      0.3s forwards;
  }
`;

const Filters = styled.div`
  position: absolute;
  top: 4rem;
  left: 1rem;
  opacity: ${({ expanded }) => (expanded ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  .filter-selection {
    display: flex;
    flex-direction: column;
  }
  .filter-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.4rem;
    .label {
      width: 6rem;
    }
  }
`;

const TagWrapper = styled.div`
  padding: 0.5rem;
  display: flex;
  flex-wrap: wrap;
`;

const HamburgerWrapper = styled.div`
  position: absolute;
  top: 0rem;
  right: 0rem;
`;

const MultipleFilter = ({
  filters,
  selectedFilters,
  removeTag,
  handleFilterChange,
  hasUserManagementAccess,
  toggleShowAddUserModal,
  site,
}) => {
  const [expanded, setExpanded] = useState(false);
  console.log("selectedFilters", selectedFilters);
  const handleHamburgerClick = () => {
    setExpanded(!expanded);
  };

  return (
    <div style={{ position: "relative", width: "100%", height: "4rem" }}>
      <Container expanded={expanded}>
        <TagWrapper>
          {selectedFilters.map((filter) => (
            <Tag
              key={0}
              tag={filter}
              handleRemoveTag={() => removeTag(filter)}
            />
          ))}
        </TagWrapper>
        <HamburgerWrapper>
          <Hamburger onClick={handleHamburgerClick} />
        </HamburgerWrapper>
        <Filters expanded={expanded}>
          <div className="labels21">Filters:</div>
          <div className="filter-selection">
            {filters.map((filter) => (
              <label className="filter-item">
                <input
                  type="checkbox"
                  name={filter?.id}
                  checked={selectedFilters.includes(filter.id)}
                  onChange={(e) =>
                    handleFilterChange(filter.id, e.target.checked)
                  }
                />
                <div className="label body10">{filter?.displayName}</div>
              </label>
            ))}
          </div>
          {hasUserManagementAccess && (
            <BloxButton
              className="buttons41 beta"
              id="add-user-button"
              text="Add User"
              module={site?.module}
              enabled={true}
              onClick={toggleShowAddUserModal}
              cypressId="add-user"
            />
          )}
        </Filters>
      </Container>
    </div>
  );
};

export default MultipleFilter;
